export * from './form.component';



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/wards/components/form/index.ts